<template>
  <UIBox
    v-if="isVisible"
    center
    grow
    uncut
    class="asb-banner"
    :style="ratio.parentStyles">
    <a
      v-if="isImg"
      center
      :href="link"
      :target="target"
      :style="ratio.parentStyles" class="asb-banner__link">
      <img
        :src="url"
        :width="width"
        :height="height"
        style="align-self: center;"
        alt="">
    </a>
    <iframe 
      v-else
      :src="url"
      :width="width"
      :height="height" 
      frameborder="0"
      scrolling="no"
      :style="ratio.iFrameStyles">
    </iframe>
  </UIBox>
</template>

<script>

export default {
  name: 'CBanner',
  props: {
    banner: Object
  },
  computed: {
    isVisible() {
      let isVisible = false
      if (this.banner && this.banner.url) {
        isVisible = true
      }
      return isVisible
    },
    isImg() {
      let isImg = false
      const formats = ['jpg', 'png', 'jpeg', 'gif', 'bmp', 'webp']
      let urlFormat = this.url.split('.')
      urlFormat = urlFormat[urlFormat.length - 1].toLowerCase()
      if (formats.indexOf(urlFormat) > -1) {
        isImg = true
      }
      return isImg
    },
    width() {
      let width
      if (this.banner.width) {
        width = this.banner.width
      } else {
        width = '100%'
      }
      return width
    },
    height() {
      let height
      if (this.banner.height) {
        height = this.banner.height
      } else {
        height = 'auto'
      }
      return height
    },
    url() {
      return this.banner.url
    },
    link() {
      return this.banner.link
    },
    target() {
      return this.banner.target || '_top'
    },
    ratio() {
      let parentStyles = {}
      let iFrameStyles = {}
      if (this.banner.ratio) {
        parentStyles = {
          position: 'relative',
          overflow: 'hidden',
          'padding-right': this.banner.ratio + '%'
        }
        iFrameStyles = {
          position: 'absolute',
          top: 0,
          left: 0
        }
      }
      return {parentStyles, iFrameStyles}
    }
  }
}
</script>
